import type { ImportStatus } from '@nest-recruit/shared';
import type { Tone } from '../../../components/Tone';

// An import's status chip, on IMP-01's header, IMP-02's and the past imports (R4). Its own file
// so the setup, the progress and the stage all read it without importing one another.

export const IMPORT_STATUS_LABELS: Readonly<Record<ImportStatus, string>> = {
  uploaded: 'Matching columns',
  mapped: 'Ready to start',
  importing: 'Importing',
  done: 'Done',
  done_with_problems: 'Done, some need you',
  cancelled: 'Cancelled',
  discarded: 'Discarded',
};

export const IMPORT_STATUS_TONES: Readonly<Record<ImportStatus, Tone>> = {
  uploaded: 'new',
  mapped: 'new',
  importing: 'progress',
  done: 'done',
  done_with_problems: 'attention',
  cancelled: 'ended',
  discarded: 'ended',
};
